var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QBtn',{staticClass:"back text-bold",attrs:{"flat":"","icon":_vm.icon('chevronLeft'),"rounded":"","to":_vm.to}},[_vm._v(" "+_vm._s(_vm.person.firstName)+" "+_vm._s(_vm.person.lastName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }